<template>
<div>
  <training-member-toolbar/>
  <div class="card mx-md-5 mt-3 mb-3 bg-form" >
    <card-header :title="$t('memberTrainings.title')" :iconName="'award'" />

    <b-card-body>
      <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
        {{ error.message }}
      </b-alert>

      <members-info :orgMember="orgMember" v-if="orgMember"> </members-info>

      <b-alert v-if="this.hasPlan && this.planList.length < 1" show variant="warning"><b-icon icon="exclamation-diamond"/> Δεν υπάρχει ενεργή εντολή.</b-alert>

      <b-alert v-if="this.orgMember.lastYearCensus===null || this.orgMember.lastYearCensus < this.currentCensus" show variant="warning"><b-icon icon="exclamation-diamond"/> Δεν έχει γίνει απογραφή για το τρέχον έτος.</b-alert>

      <div v-if="this.hasPlan" >
        <template v-for="plan in this.planList">
          <PlanComponent :plan="plan" v-bind:key="plan.id"/>
        </template>
      </div>

      <hr/>

      <MemberTrainingTable :orgMember="this.orgMember" :trainingsList="this.trainingsList" />

    </b-card-body>
  </div>
</div>
</template>

<script>
import cardHeader from '../../components/common/cardHeader'
import trainingService from '../../services/training.service';
import {handleApiError} from '../../services/error.service';
import PlanComponent from "@/components/progress/PlanComponent";
import MemberTrainingTable from "@/components/progress/memberTrainingsTable";
import TrainingMemberToolbar from "@/components/TrainingMemberToolbar";
import MembersInfo from "../../components/progress/membersInfo.vue";

export default {
  components: {
    TrainingMemberToolbar,
    PlanComponent,
    cardHeader,
    MemberTrainingTable,
    MembersInfo
},
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;
      },
      (error) => {
        this.handleError(handleApiError(error))
      }
    );
    trainingService.getCurrentCensusPeriod().then(
        (response) => {
          this.currentCensus = response.data.yearCensus;
        },
        (error) => {
          this.handleError(handleApiError(error))
        }
    );
    trainingService.getMemberById(this.$route.params.id).then(
      (response) => {
        this.orgMember = response.data;
        // if (!['LEADER', 'ROVER'].includes(this.orgMember.type)){
        //   window.location.href = `/app/training/web/apply-activities/trainee/${this.orgMember.id}`;
        // }
        if (this.hasPlan) {
          this.getProgressPlans(this.orgMember.id);
        }
        this.getMemberTrainings(this.orgMember.id);
      }
    );

  },
  data() {
    return {
      orgMember: null,
      planList: null,
      errors: [],
      trainingsList: [],
      popAlert: false,
      currentCensus: 1908,
    }
  },
  computed: {
    hasPlan() {
      return this.orgMember.type? ['LEADER', 'ROVER'].includes(this.orgMember.type): true;
    }
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    getProgressPlans(memberId) {
      this.trainingsList = [];
      trainingService.getMemberProgress(memberId).then(
        (response) => {
          this.planList = response.data;
        },
        (error) => {
          this.handleError(handleApiError(error));
        }
      )
    },
    getMemberTrainings(memberId) {
      trainingService.getMemberTrainings(memberId).then(
          (response) => {
            this.trainingsList = response.data;
          },
          (error) => {
            this.handleError(handleApiError(error));
          }
      )
    }
  }
}
</script>